import _ from 'lodash';

import apiFetch from '@scale/frontend-lib/api-fetch';
import {
  OverviewTypeParams,
  OverviewTypeResponse,
  RedashOverviewParams,
  RedashDownloadParams,
  TableauOverviewParams,
  TableauOverviewResponse,
  CustomerMetricsOverviewParams,
  CustomerMetricsOverviewResponse,
  RedashOverviewResponse,
} from '@scale/shared/types/endpoints/customer/overview';

export async function getOverviewType(params: OverviewTypeParams): Promise<OverviewTypeResponse> {
  const query = _.omitBy(params, _.isNil);
  return apiFetch(null, 'internal/overview/type', { query });
}

export async function getTableauOverview(
  params: TableauOverviewParams,
): Promise<TableauOverviewResponse> {
  const query = _.omitBy(params, _.isNil);
  return apiFetch(null, 'internal/overview/tableau', { query });
}

export async function getCustomerMetricsOverview(
  params: CustomerMetricsOverviewParams,
): Promise<CustomerMetricsOverviewResponse> {
  const query = `startDate=${params.startDate}&endDate=${params.endDate}`;
  return apiFetch(null, `internal/overview/customer-metrics?${query}`);
}

export const getRedashOverview = async (
  params: RedashOverviewParams,
): Promise<RedashOverviewResponse> => {
  const query = _.omitBy(params, _.isNil);
  return apiFetch(null, 'internal/overview/redash', { query });
};

export const getRedashCSV = async (params: RedashDownloadParams): Promise<string> => {
  const query = _.omitBy(params, _.isNil);
  const response = await apiFetch(null, 'internal/overview/redash/downloadCSV', { query });
  return response;
};
